import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import { RegisterUserBrandingPanel } from '@features/register-user/components/register-user-branding-panel/RegisterUserBrandingPanel';
import { RegisterUserFormPanel } from '@features/register-user/components/register-user-form-panel/RegisterUserFormPanel';
import { RegisterUserHelpBar } from '@features/register-user/components/register-user-help-bar/RegisterUserHelpBar';
import { useRegisterUserContent } from '@pages/register-user/hooks/use-register-user-content/useRegisterUserContent';
import { AuthErrorScreen } from '@shared/components/error-pages/auth-error/AuthErrorScreen';
import * as React from 'react';

import styles from './RegisterUserPage.module.css';

const RegisterUserPage = React.memo((): React.ReactElement => {
  const {
    emailExists,
    isLoggingIn,
    loginError,
    handleNavigateToLanding,
    handleSubmitSuccess,
    handleEmailExists,
    handleBackToForm,
  } = useRegisterUserContent();

  if (isLoggingIn) {
    return (
      <div role="status" aria-label="Creating your account">
        <CobaltLoaderCircular />
      </div>
    );
  }

  if (loginError) {
    return <AuthErrorScreen onRetry={handleSubmitSuccess} />;
  }

  return (
    <div className={styles.registerUserPage} data-testid="register-user-page">
      <RegisterUserBrandingPanel />
      <main className={styles.formPanel}>
        <RegisterUserHelpBar emailExists={emailExists} />
        <RegisterUserFormPanel
          emailExists={emailExists}
          onNavigateToLanding={handleNavigateToLanding}
          onSubmitSuccess={handleSubmitSuccess}
          onEmailExists={handleEmailExists}
          onBackToForm={handleBackToForm}
        />
      </main>
    </div>
  );
});

RegisterUserPage.displayName = 'RegisterUserPage';

export { RegisterUserPage };
